import(/* webpackMode: "eager", webpackExports: ["AuthCard"] */ "/vercel/path0/src/app/(auth)/_components/auth-card.tsx");
